import {
  FunctionComponent,
  useMemo,
  type CSSProperties,
  useState,
  useEffect,
} from "react";
import firrtimeforward from "../../assets/dashboard/firrtimeforward.svg";
import firsuser from "../../assets/dashboard/firsuser.svg";
import firrdocument from "../../assets/dashboard/firrdocument.svg";
import { ApolloError, useMutation } from "@apollo/client";
import Loader from "../common/Loader";
import { showError, showSuccess } from "../common/ToastNotification";
import { UPDATE_TASKS_MUTATION } from "../../api/mutation";
import InputsDropdown from "../common/InputsDropdown";
import { useNavigate } from "react-router-dom";

interface DashTaskRowProps {
  person: string;
  // dropdownplaceholder?: string;
  label: string;
  date: string;
  // option: any;
  taskId: any;
  // uuid: any;
  taskData: any;
  readOnly: any;
  /** Style props */
  propBackgroundColor?: CSSProperties["backgroundColor"];
  propBorder?: CSSProperties["border"];
  propColor?: CSSProperties["color"];
  // refetch?: any;
  // agencyID?: any;
  projectName?: string
  goalID?: string
  assignedPerson?: string
}

const getStatusClass = (status: string) => {
  switch (status) {
    case "In Progress":
      return "inprogress_btn_dv";
    case "Waiting":
      return "newstatus_btn_dv";
    case "Done":
      return "complated_btn_dv";
    case "Not Started":
      return "close_btn_dv";
    default:
      return "";
  }
};
const DashTaskRow: FunctionComponent<DashTaskRowProps> = ({
  person,
  // dropdownplaceholder,
  label,
  date,
  // option,
  taskId,
  readOnly,
  taskData,
  // uuid,
  // agencyID,
  // refetch,
  projectName,
  goalID,
  assignedPerson
}) => {
  const navigate = useNavigate()

  const [selectedOption, setSelectedOption] = useState("");
  const [statusClass, setStatusClass] = useState("");

  // Mutation task update
  const [updateTask, { loading: updateLoading }] = useMutation(
    UPDATE_TASKS_MUTATION,
    {
      fetchPolicy: "no-cache",
    }
  );

  useEffect(() => {
    const task = taskData.find((task: any) => task.id === taskId);
    if (task) {
      setSelectedOption(task.task_status); // Initial value for dropdown
      setStatusClass(getStatusClass(task.task_status)); // Set class based on initial status
    }
  }, [taskId, taskData]);

  // update_tasks
  // const handleSelect = (option: any, formData: any, value: string) => {
  //   setSelectedOption(formData);
  //   setStatusClass(getStatusClass(formData)); // Update class based on new selection

  //   updateTask({
  //     variables: {
  //       task_id: Number(taskId), // Pass the task ID dynamically
  //       task_status: formData, // Selected status
  //       updated_by: uuid, // The user making the update
  //     },
  //   })
  //     .then((response) => {
  //       const { message, status_code } = response.data.update_tasks;
  //       if (status_code) {
  //         showSuccess(message);
  //         refetch({
  //           fetchPolicy: "no-cache",
  //           variables: {
  //             client_location_id: agencyID,
  //             employee_id: uuid,
  //             page: 1,
  //             page_size: 3,
  //           },
  //         });
  //         return true;
  //       }
  //     })
  //     .catch((error) => {
  //       if (error instanceof ApolloError) {
  //         showError(error.message);
  //         return false;
  //       } else {
  //         showError(error);
  //         return false;
  //       }
  //     });
  // };

  if (updateLoading) {
    return <Loader />;
  }

  return (
    <div
      id="tabel-row"
      className={`self-stretch bg-surface-bg-primary flex flex-row items-start justify-start box-border gap-[20px] max-w-full text-left text-sm text-colors-text-black font-body-xs-semi-bold mq950:flex-wrap ${readOnly == true ? "opacity-[0.4]" : ""
        }`}
    >
      <div className="flex-1 flex flex-col items-start justify-start gap-[8px] min-w-[282px] max-w-full ">
        <div className="self-stretch flex flex-row items-start justify-start gap-[8px]">
          {/* <img
            className="h-[15px] w-[15px] relative overflow-hidden shrink-0"
            alt=""
            src={firrdocument}
          /> */}
          <p
            className="relative font-bold text-sm my-0 dark:text-white taskdetails-content"
            dangerouslySetInnerHTML={{ __html: label }}
          ></p>
        </div>
        <div className=" self-stretch flex flex-row items-start justify-start gap-[8px] text-xs text-text-text-secondary mq450:flex-wrap mq450:grid mq450:gap-[16px]">
          {/* <p className="text-sm my-0 dark:text-white relative inline-block font-semibold">Assigned By:</p>
          <div className="flex flex-row items-center justify-start py-0  pl-0 gap-[4px] ">
            <img
              className="h-3 w-3 relative overflow-hidden shrink-0"
              alt=""
              src={firsuser}
            />
            <p className="text-sm my-0 dark:text-white relative">{person}</p>
          </div> */}
          <p className="relative inline-blocktext-sm my-0 dark:text-white font-semibold">Assigned To:</p>
          <div className="flex flex-row items-center justify-start py-0  pl-0 gap-[4px] ">
            <img
              className="h-3 w-3 relative overflow-hidden shrink-0"
              alt=""
              src={firsuser}
            />
            <p className="text-sm my-0 dark:text-white relative">{assignedPerson}</p>
          </div>
          <p className="relative inline-block text-sm my-0 dark:text-white font-semibold">Project Name:</p>
          <div className="flex flex-row items-center justify-start py-0 pl-0 gap-[4px]">
            {/* <img
              className="h-3 w-3 relative overflow-hidden shrink-0"
              alt=""
              src={firrtimeforward}
            /> */}
            <p className="relative capitalize text-sm my-0 dark:text-white ">{projectName}</p>
          </div>
          <div className="flex flex-row items-center justify-start py-0 pl-0 gap-[4px]">
            <img
              className="h-3 w-3 relative overflow-hidden shrink-0"
              alt=""
              src={firrtimeforward}
            />
            <p className="relative capitalize text-sm my-0 dark:text-white font-semibold">{date}</p>
          </div>
        </div>
      </div>
      <div className={`${statusClass} min-w-[131px] viewgoal_dash_btn_dv flex items-start justify-center`}>
        <button
          onClick={() => {
            navigate('/goal_view', {
              state: {
                goalID: goalID,
                projectName: projectName,
              }
            })
          }}
        >
          View Goal
        </button>
      </div>
      <div className="dash_tasknew_label_dv flex items-start justify-center">
        <p className="my-0 text-sm dark:text-white">New</p>
      </div>
      {/* <div className={`${statusClass} min-w-[131px]`}>
        <InputsDropdown
          label=""
          options={[]}
          placeHolder={"New"}
          // disableDropdown={readOnly == true}
          // onSelect={handleSelect}
          // initialValue={selectedOption}
        />
      </div> */}
    </div>
  );
};

export default DashTaskRow;
